exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notice-wrap .notice[data-v-577a662a]{width:100%;font-size:15px;font-family:'RobotoRegular';font-weight:normal;color:#171717;line-height:22px;margin-bottom:10px}.notice-wrap .notice.mb[data-v-577a662a]{font-size:15px;line-height:.44rem;margin-bottom:.2rem;margin-top:.1rem}\n", ""]);

